import ocLazyLoad from  "oclazyload/dist/ocLazyLoad";

export default "oc.lazyLoad";



// WEBPACK FOOTER //
// ./src/ui/app/services/ocLazyLoad.js